var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isPdf)?_c('el-image',{staticClass:"info-pic",attrs:{"src":_vm.src,"preview-src-list":_vm.list}}):_c('img',{staticClass:"info-pdf",attrs:{"src":require("../../assets/images/pdf.png")},on:{"click":_vm.download}})
}
var staticRenderFns = []

export { render, staticRenderFns }